module.exports = __webpack_public_path__ + "img/commission-slide.97af4961.svg";